import React from 'react';

import NavGroup from './NavGroup';
import menuItem from '../../../../Route/navItems';
import PagePath, { PageType } from '../../../../Route/PagePath';
import NavCollapse from './NavCollapse';
import NavItem from './NavItem';
import { Typography } from '@material-ui/core';
import SessionHelper from '../../../../Core/SessionHelper';

const MenuList = () => {
    const session = SessionHelper.GetSession();
    const isSuperAdmin =
        session?.RoleName?.toLowerCase() === 'super admin' ||
        session?.RoleName?.toLowerCase() === 'admin' ||
        !session?.AllowedRoutePaths?.length;
    const allowedPaths = session?.AllowedRoutePaths || [];

    const filterMenu = (items: PagePath[]): PagePath[] => {
        if (isSuperAdmin) return items;
        return items.filter(item => {
            if (item.type === PageType.group || item.type === PageType.collapse) {
                const subItems = filterMenu(item.content || []);
                item.content = subItems;
                return subItems.length > 0;
            }
            if (item.to) {
                return allowedPaths.includes(item.to) || item.to === '/dashboard';
            }
            return true;
        });
    };

    const filteredMenuItems = filterMenu(menuItem());

    const navItems = filteredMenuItems.filter(i => i.ShowInNavbar).map((item: PagePath) => {

        switch (item.type) {
            case PageType.group:
                return <NavGroup key={item.label} item={item} />
            case PageType.collapse:
                return <NavCollapse key={item.label} menu={item} level={1} />
            case PageType.item:
                return <NavItem key={item.label} item={item} level={1} />
            default:
                return (
                    <Typography key={item.label} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <> {navItems}</>;
};

export default MenuList;
